import React, { useEffect, useState } from "react";
import { Box, Grid } from "@mui/material";
import styles from "./styles/styles.module.css";
import { Formik, Form, } from "formik";
import * as Yup from "yup";
import apiEndPoint from "../../services/apiService/apiEndPoints";
import {  postApi } from "../../services/apiService/fetchMethod";
import tostMessage from "../../utils/tostMessage";
import { useLocation, } from "react-router-dom";
import FormikInput from "../../commonComponents/InputField/FormikInput";
import Modal from "@mui/material/Modal";
import MainLoader from "../../commonComponents/loader/MainLoader";
import { Switch } from "antd";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};
function SecondStep({ setStep }) {
  let { state } = useLocation();
  const [passwordSentMail, setPasswordSentMail] = useState(true);
  const [open, setOpen] = React.useState(state ? false : true);
  const [userFound, setUserFound] = useState(false);
  const [loading, setLoading] = useState(false);
  const [disableField, setDisableField] = useState(0);
  const [ dataForUser, setDataForUser ] = useState({
    roleId: null,
    clusterId: null,
    alertId: null,
    project_id:null
  });
  const [initialVal, setInitialVal] = useState({
    firstName: state ? state?.user_first_name : "",
    lastName: state ? state?.user_last_name : "",
    phone: state ? maskNumber(state?.user_phone) : "",
    email: state ? state?.user_email : "",
    profile_img: state?.profile_img ? state.profile_img : "",
    password: state ? "password" : null,
  });

  useEffect(() => {
    if (state) {
      if (state.user_cluster_id) {
        setDisableField(1);
      } else {
        setDisableField(2);
      }
    }
  }, [state]);

  useEffect(() => {
    (async () => {
      const url = apiEndPoint().For_user_create;
      const { status, data } = await postApi({
        url,
        params: { code: localStorage.getItem("code") },
      });
      if (status === 200) {
        console.log(status, data);
        setDataForUser(data.data);
      }
    })();
  }, []);

  const handleSubmit = async (val) => {
    if (!dataForUser.roleId || !dataForUser.clusterId || !dataForUser.alertId) {
      return tostMessage(300, "Somthing went wrong");
    }
    setLoading(true);
    const {
      firstName,
      lastName,
      email,
      password,
      phone,
      profile_img,
    } = val;
    let url = state?._id
      ? apiEndPoint().UPDATE_USER
      : apiEndPoint().CREATE_NEW_USER2;
    const { status, data } = await postApi({
      url,
      params: {
        id: state?._id,
        firstName,
        lastName,
        email,
        password: passwordSentMail ? null : password,
        phone,
        user_role_id: dataForUser.roleId ,
        supervisor: {
          label: "Harshit Bhatia",
          value: "64e68313ee064324b45adcef",
        },
        user_cluster_id: dataForUser.clusterId ,
        profile_img,
        alerts: dataForUser.alertId,
        selected_project:dataForUser.project_id
      },
    });
    tostMessage(status, data?.message);
    if (status === 200) {
      return setStep(2);
    }
    setLoading(false);
    console.log(status, data);
  };

  function maskNumber(number) {
    const strNumber = number.toString();

    if (strNumber.length > 4) {
      const firstTwo = strNumber.slice(0, 2);
      const lastTwo = strNumber.slice(-2);
      const maskedMiddle = "*".repeat(strNumber.length - 4);
      return `${firstTwo}${maskedMiddle}${lastTwo}`;
    } else {
      return strNumber;
    }
  }
  const validationSchema = Yup.object().shape({
    firstName: Yup.string()
      .required("First name is required")
      .matches(
        /^[a-zA-Z][a-zA-Z0-9_. -]{0,29}$/,
        "Only letters are allowed in the name"
      ),
    lastName: Yup.string()
      .required("First name is required")
      .matches(
        /^[a-zA-Z][a-zA-Z0-9_. -]{0,29}$/,
        "Only letters are allowed in the name"
      ),
    phone: state?.user_phone
      ? Yup.string()
      : Yup.string()
          .matches(/^[1-9][0-9]{9}$/, "Invalid phone number")
          .required("Phone number is required"),
    email: Yup.string()
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        "Invalid email address"
      )
      .required("Email is required"),
    password: !passwordSentMail
      ? Yup.string()
          .test(
            "password",
            "Password must contain at least one lowercase letter",
            (value) => /^(?=.*[a-z])/.test(value)
          )
          .test(
            "password",
            "Password must contain at least one uppercase letter",
            (value) => /^(?=.*[A-Z])/.test(value)
          )
          .test(
            "password",
            "Password must contain at least one digit",
            (value) => /^(?=.*\d)/.test(value)
          )
          .test(
            "password",
            "Password must contain at least one special character",
            (value) => /^(?=.*[@$!%*?&])/.test(value)
          )
          .test(
            "password",
            "Password must be at least 8 characters long",
            (value) => value.length >= 8
          )
          .required("This Field is required")
      : null,
  });
  const handleSearch = async (val, setFieldValue) => {
    let url = apiEndPoint().GET_ONE_USER2;
    let { data, status } = await postApi({
      url,
      params: { email: val.emaiToSearch },
    });
    console.log(data, status);

    if (status === 200) {
      tostMessage(400, "User Already exist");
    }

    if (status === 404) {
      setFieldValue("email", val.emaiToSearch);
      setFieldValue("phone", val.phoneToSearch);
      setOpen(false);
    }
  };
  if (loading) {
    return <MainLoader />;
  }
  return (
    <div style={{ padding: "3rem" }}>
      <h3
        style={{
          display: "flex",
          justifyContent: "end",
          alignItems: "center",
        }}
      >
        {state ? (
          <div></div>
        ) : (
          <Switch
            checkedChildren="Password Send on mail"
            unCheckedChildren="Create Password"
            checked={passwordSentMail}
            onChange={(val) => setPasswordSentMail(val)}
          />
        )}
      </h3>
      <Formik
        initialValues={initialVal}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ touched, errors, setFieldValue, values, setFieldTouched }) => (
          <Form>
            <Grid
              container
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
              rowSpacing={0.5}
            >
              <Grid item xs={12} sm={6}>
                <FormikInput
                  placeholder="First name"
                  labelVal="First Name"
                  name="firstName"
                  touched={touched.firstName}
                  errors={errors.firstName}
                  readOnly={state || userFound ? true : false}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormikInput
                  placeholder="Last name"
                  labelVal="Last Name"
                  name="lastName"
                  touched={touched.lastName}
                  errors={errors.lastName}
                  readOnly={state || userFound ? true : false}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormikInput
                  placeholder="Email"
                  type="email"
                  labelVal="Email"
                  name="email"
                  touched={touched.email}
                  errors={errors.email}
                  readOnly={state || userFound ? true : false}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormikInput
                  placeholder="Phone Number"
                  labelVal="Phone no"
                  name="phone"
                  touched={touched.phone}
                  errors={errors.phone}
                  readOnly={state || userFound ? true : false}
                />
              </Grid>

              {/* <Grid item xs={12} sm={6}>
                <div style={{ marginBottom: "0.4rem" }}>
                  <label style={{ fontWeight: "500" }}>User Profile</label>
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <img
                    src={
                      !values.profile_img
                        ? "https://modernize-angular-main.netlify.app/assets/images/profile/user-1.jpg"
                        : values.profile_img
                    }
                    alt="selectedImg"
                    height={50}
                    width={50}
                    style={{ marginInline: "6px", borderRadius: "5px" }}
                  />
                  <label
                    htmlFor="profile_img"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      color: state || userFound ? "gray" : "blue",
                      fontWeight: "600",
                      fontSize: "12px",
                      cursor: state || userFound ? "not-allowed" : "pointer",
                    }}
                  >
                    <CloudUploadIcon />
                    <span
                      style={{
                        marginInline: "10px",
                        color: state || userFound ? "gray" : "blue",
                        cursor: state || userFound ? "not-allowed" : "pointer",
                      }}
                    >
                      Upload logo
                    </span>{" "}
                  </label>
                  <input
                    id="profile_img"
                    type="file"
                    accept="image/*"
                    onChange={(e) => {
                      !state && handleImgUpload(e, setFieldValue);
                    }}
                    style={{ visibility: "hidden" }}
                    disabled={state}
                  />
                </div>
              </Grid> */}
              {!passwordSentMail && !state && (
                <Grid item xs={12} sm={6}>
                  <FormikInput
                    placeholder="Enter password"
                    labelVal="Enter Password"
                    name="password"
                    type="password"
                    touched={touched.password}
                    errors={errors.password}
                    readOnly={state || userFound ? true : false}
                  />
                </Grid>
              )}
            </Grid>
            <div
              className={styles.addRole}
              style={{ marginBlock: "1rem", justifyContent: "end" }}
            >
              <button type="submit" className={styles.buttonAddRole}>
                {state ? "Update User" : <>Submit</>}
              </button>
            </div>

            <Modal
              open={open}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style}>
                <Formik
                  initialValues={{ emaiToSearch: "", phoneToSearch: "" }}
                  validationSchema={Yup.object().shape({
                    emaiToSearch: Yup.string()
                      .matches(
                        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                        "Invalid email address"
                      )
                      .required("Email is required"),
                  })}
                  onSubmit={(val) => handleSearch(val, setFieldValue)}
                >
                  {({
                    touched,
                    errors,
                    setFieldValue,
                    values,
                    setFieldTouched,
                  }) => (
                    <Form>
                      <FormikInput
                        placeholder="Email"
                        type="email"
                        labelVal="Email"
                        name="emaiToSearch"
                        touched={touched.emaiToSearch}
                        errors={errors.emaiToSearch}
                      />
                      <div
                        className={styles.addRole}
                        style={{ marginBlock: "1rem", justifyContent: "end" }}
                      >
                        <button type="submit" className={styles.buttonAddRole}>
                          Submit
                        </button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </Box>
            </Modal>
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default SecondStep;
